function MotoWidget({ tekst }) {
    return <>
        <div className="sidewidget" dangerouslySetInnerHTML={{ __html: tekst }}></div>
    </>
}

export default MotoWidget